var exports = {
  "k": "x4c3adb35--d3f383--container",
  "n": "x4c3adb35--d3f383--link",
};

module.exports = exports;
